// @ts-ignore
import { fetchDedupe } from 'fetch-dedupe';

export const dynamicImportClientJSWithRetry = async (mfeManifest: any): Promise<any> => {

  let maxAttempts = 2
  let updatedManifest = mfeManifest;
  for (let currentAttempt = 1; currentAttempt <= maxAttempts; currentAttempt++) {
    const url = updatedManifest.client.url
    try {
      const module = await import(/* @vite-ignore */ url)
      return module
    } catch (error) {
      console.debug('failed to dynamically import js, refreshing manifest, trying again', { url: url, currentAttempt: currentAttempt, error: error })
      const mfeManifestResponse = await fetchDedupe(`/api/web-shop/manifest/${updatedManifest.name}`)
      updatedManifest = mfeManifestResponse.data

    }
  }

  return Promise.reject('failed to dynamically import after max attempts')

}

export const dynamicImportClientCSSWithRetry = async (mfeManifest: any): Promise<any> => {

  let maxAttempts = 2
  let updatedManifest = mfeManifest;

  for (let currentAttempt = 1; currentAttempt <= maxAttempts; currentAttempt++) {
    const url = updatedManifest.client.css;
    const cssId = url;
    const existingCssInDom = document.getElementById(cssId);
    if (!existingCssInDom) {
      try {

        if (!url) {
          throw new Error('no mfe client css url available');
        }
        const fetchOptions = {
          method: 'GET',
          responseType: 'text'
        };
        const cssResponse = await fetchDedupe(url, fetchOptions);
        if (!cssResponse.ok) {
          throw new Error('not OK');
        }
        const cssResponseText = cssResponse.data;
        if (cssResponseText) {
          loadCSS(updatedManifest, cssResponseText)
        }
        return;
      } catch (error) {
        console.debug('failed to dynamically import css, refreshing manifest, trying again', { url: url, currentAttempt: currentAttempt, error: error });
        const mfeManifestResponse = await fetchDedupe(`/api/web-shop/manifest/${updatedManifest.name}`);
        updatedManifest = mfeManifestResponse.data
      }
    }
  }

  return Promise.reject('failed to dynamically import css after max attempts')

}

const loadCSS = (mfeManifest: any, css: string) => {
  const cssId = mfeManifest.client.css;
  const existingCssInDom = document.getElementById(cssId);
  if (!existingCssInDom && css) {
    // const targetElement = document.getElementsByTagName('head')[0];
    const targetElement = document.getElementById('mfeStyles');

    // TODO: remove once registry and faq moves away from using relative urls for images
    if (mfeManifest?.name === 'registry' || mfeManifest?.name === 'faq') {
      const link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet'
      link.href = mfeManifest.client.css
      targetElement?.appendChild(link);
      return;
    }

    const style = document.createElement('style');
    style.id = cssId;
    style.appendChild(document.createTextNode(css));
    targetElement?.appendChild(style);

  }
}
